<template>
  <div class="c-idea g-container">
    <Breadcrumb class="m-bread">
      <BreadcrumbItem> <Icon type="ios-home-outline"></Icon> 选择投放账号 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="logo-buffer"></Icon> 设置计划组 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="ios-cafe"></Icon> 设置创意 </BreadcrumbItem>
    </Breadcrumb>

    <!-- 滚动区域 -->
    <div class="module-content" ref="container">
      <moduler v-for="item in subModules" :key="item.id" :title="item.name" :name="item.href">
        <Spin size="large" fix v-if="!show"></Spin>
        <template v-if="item.href === 'idea_tool'">
          <affix target="c-create-scroll" :offsetTop="65">
            <div class="c-idea-bar">
              <div ref="barContent" class="c-bar-content">
                <template v-for="(creative, i) in creativeData">
                  <div :key="i" @click.stop="setIdea(i)" :class="classes(creative)">
                    <span>创意组{{ i + 1 }}</span>
                    <span class="m-remove" @click.stop="delIdea(i)">x</span>
                  </div>
                </template>
              </div>
              <div class="c-add-btn">
                <!-- 投放方式不是全自动投放时显示，全自动投放不能添加多个创意组 -->
                <Button icon="ios-add" v-if="deliveryMethod !== 3" :disabled="ideaLen" @click.stop="appendIdea">添加创意组</Button>
                <Button type="info" disabled @click.stop="campaignModal = true">选择创意组</Button>
                <!-- :disabled="!accountData.length" -->
              </div>
            </div>
          </affix>
        </template>

        <template v-if="item.href === 'idea_base' && show">
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">创意组名称</span>
            </Col>
            <Col span="12">
              <input-len v-model="formItem.ideaName" placeholder="最大20个字符，1个中文等于2个字符" width="480" :max="20" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">创意名称</span>
            </Col>
            <Col span="12">
              <input-len v-model="formItem.creative_name" placeholder="最大96个字符，1个中文等于2个字符" width="480" :max="96" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field">计划位置</span>
            </Col>
            <Col span="12">
              <RadioGroup :value="formItem.scene" type="button" v-if="formItem.union">
                <Radio :label="5">快手计划联盟</Radio>
              </RadioGroup>
              <RadioGroup v-model="formItem.scene" type="button" v-else @on-change="changScene">
                <Radio :label="1">优选计划位</Radio>
                <Radio :label="2">按场景选择计划位</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="formItem.scene === 2">
            <Col span="4" class="col-item">
              <span class="item-field">&nbsp;</span>
            </Col>
            <Col span="12">
              <CheckboxGroup v-model="formItem.scene_id">
                <Checkbox :label="6">上下滑大屏计划</Checkbox>
                <Checkbox :label="10">快手联盟优选计划</Checkbox>
                <Checkbox :label="24">激励视频计划</Checkbox>
                <!-- <Checkbox :label="7">信息流广告</Checkbox> -->
              </CheckboxGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field">创意形式</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.unit_type" type="button" @on-change="initCreatives">
                <Radio :label="4">自定义</Radio>
                <Radio :label="7">程序化</Radio>
              </RadioGroup>
            </Col>
          </Row>
        </template>

        <template v-if="item.href === 'idea_media' && show">
          <!-- 自定义 -->
          <Row class="row-item" :gutter="12" v-if="formItem.unit_type === 4">
            <Col span="24">
              <creatives
                :data="formItem.creatives"
                :source="formItem.creativeDetails"
                :words="wordData"
                :game-data="gameData"
                :game-group-data="gameGroupData"
                :operator-data="operatorData"
                :label-data="labelData"
                :max="15"
                :verify="verify"
                :scene-id="formItem.scene"
                :open-id="opId"
                :game-id="gameId"
                :media="media"
                @on-splice="spliceCreative"
              />
            </Col>
          </Row>
          <!-- 程序化 -->
          <Row class="row-item" :gutter="12" v-else>
            <Col span="24">
              <smarts
                v-model="formItem.smart_cover"
                :data="formItem.creatives"
                :source="formItem.creativeDetails"
                :words="wordData"
                :game-data="gameData"
                :game-group-data="gameGroupData"
                :operator-data="operatorData"
                :label-data="labelData"
                :verify="verify"
                :scene-id="formItem.scene"
                :open-id="opId"
                :game-id="gameId"
                :media="media"
                @on-add="pushCreative"
                @on-replace="replaceCreative"
                @on-delete="delCreative"
                @on-sticker="selectSticker"
              />
            </Col>
          </Row>
        </template>

        <template v-if="item.href === 'idea_position' && show">
          <Row class="row-item" :gutter="12" v-show="formItem.unit_type === 7">
            <Col span="4" class="col-item">
              <span class="item-field">素材挖掘</span>
            </Col>
            <Col span="12" class="col-flex">
              <i-Switch v-model="formItem.asset_mining" />
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">创意分类</span>
            </Col>
            <Col span="12">
              <category :title="['创意分类']" :value="formItem.mult_categroy" :data="categroyData" @on-select="selectCategroy" />
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">创意标签</span>
            </Col>
            <Col span="12">
              <add-tags v-model="formItem.creative_tag" :open-id="opId" @on-close="closeTag" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field">点击监测链接</span>
            </Col>
            <Col span="12">
              <Input readonly placeholder="内部计划自动生成" />
            </Col>
          </Row>
        </template>
      </moduler>
    </div>

    <affix target="c-create-scroll" :offsetBottom="0">
      <div class="c-idea-submit">
        <Row :gutter="12">
          <Col span="12">
            <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
          </Col>
          <Col span="12" class="c-btns-submit">
            <Button type="default" @click.stop="back">上一步</Button>
            <Button type="primary" @click.stop="submit">下一步</Button>
          </Col>
        </Row>
      </div>
    </affix>
  </div>
</template>
<script>
import mixin from './mixin'
import ideaMixin from './idea_mixin'

import creativeTemplate from '@/data/kuaishou/creative.json'
import creativeLinkTemplate from '@/data/kuaishou/creative_link.json'
import creativeMiniGameTemplate from '@/data/kuaishou/creative_minigame.json'

import { getSession, setSession, setLocalforage } from '@/common/js/api'
import { trim, isArray, timeout, deepCopy, pullKeys, clearStrKey } from '@/common/js/utils'

import { adAccount, adGames, getSysTag, getCaoHuaOpenIds } from '@/api/common.model'
import { getPtomGroupGames } from '@/api/material.model'
import { getCreativeWords, getCreativeCategory, getCreativeStyles } from '@/api/kuaishou.model'

import Category from './components/idea/selecter/category.vue'
import AddTags from './components/idea/selecter/add-tags.vue'
import Creatives from './components/idea/creative/creative.vue'
import Smarts from './components/idea/creative/smart.vue'

const defaultIdeaParams = {
  ideaName: '',
  creative_name: '',

  creatives: [], // 创意数组
  creativeDetails: [],
  gift: false, // 发送礼包码
  target_action_type: 30,
  code: '',
  asset_mining: false, // 素材挖掘
  creative_category: 0,
  creative_tag: [],
  mult_categroy: []
}

const defautWords = ['日期', '星期', '节日', '年龄范围', '地区']

export default {
  name: 'ksLocalIdea',
  mixins: [mixin, ideaMixin],
  components: { Creatives, Smarts, Category, AddTags },
  provide: function () {
    return {
      getIdeaCompInstance: this
    }
  },
  data() {
    return {
      show: null, // 初始化append
      campaignModal: null,
      deliveryMethod: 1,
      creativeData: [],
      categroyData: [],
      styleData: [],
      wordData: [],
      accountData: [], // 选择创意的账号
      operatorData: [],
      gameData: [],
      gameGroupData: [],
      labelData: [],
      platform: 0,
      gameId: 0,
      verify: false
    }
  },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    isAndroid() {
      return this.platform === 1
    },
    formItem() {
      const items = this.creativeData.filter((ret) => ret.check)
      return items.pop() || {}
    },
    ideaLen() {
      return this.creativeData.length >= 100
    },
    classes() {
      return (item) => {
        return ['m-creative-btn', { 'm-current': item.check }]
      }
    },
    addState() {
      return this.formItem.creatives.length < 5
    },
    isLink() {
      const planInfo = getSession('inner_plan_params')
      return planInfo.landing_type === 'LINK'
    },
    isMiniGame() {
      const planInfo = getSession('inner_plan_params')
      return planInfo.ch_platform_id === 3
    }
  },
  methods: {
    preloadData() {
      const param = { ad_account_id: this.adAccount }
      Promise.all([
        getCreativeWords(param),
        getCreativeCategory(param),
        getCreativeStyles(param),
        getCaoHuaOpenIds(),
        adGames({ type: 1 }),
        getPtomGroupGames(),
        getSysTag()
      ]).then((data) => {
        const [words, categories, styles, operatorData, gameData, gameGroupData, labels] = data
        if (isArray(words) && this.scene !== 5) {
          this.wordData = words
            .filter((ret) => defautWords.includes(ret.name))
            .map((ret) => {
              ret.max_word_length += ret.max_word_length
              return ret
            })
        }
        if (isArray(categories)) this.categroyData = categories
        if (isArray(styles)) this.styleData = styles
        if (isArray(operatorData)) this.operatorData = operatorData
        if (isArray(gameData)) this.gameData = gameData
        if (isArray(gameGroupData)) {
          this.gameGroupData = gameGroupData.map((ret) => {
            return {
              id: ret.groupId,
              name: ret.groupName,
              children: ret.gameIds
            }
          })
        }
        if (isArray(labels)) {
          this.labelData = labels.map((ret) => {
            return {
              id: ret.labelId,
              name: ret.content
            }
          })
        }
        if (this.editState) this.getData()
        else {
          this.appendIdea() // 增加一个创意
          this.setIdea(0)
          this.show = true
        }
      })
    },
    // 切换自定义
    initCreatives(val) {
      const material = []
      this.$set(this.formItem, 'creatives', [])
      if (val === 7) {
        const { smart } = deepCopy(this.formItem.creativeElements)
        smart && material.push(smart)
      }

      this.$set(this.formItem, 'creatives', material)
    },
    appendIdea() {
      const len = this.creativeData.length
      const fmt_formItem = deepCopy(this.formItem)
      let ideaParam = Object.assign({}, defaultIdeaParams, fmt_formItem) // 复制

      if (this.platform === 2) ideaParam.target_action_type = 2 // 发送时机
      let cTemplate = deepCopy(creativeTemplate)
      if (this.isMiniGame) {
        cTemplate = deepCopy(creativeMiniGameTemplate)
      } else if (this.isLink) {
        cTemplate = deepCopy(creativeLinkTemplate)
      }
      cTemplate.smart.template[2].children = deepCopy(this.styleData)
      ideaParam = Object.assign(
        {},
        {
          unit_type: this.unitType,
          smart_cover: this.smartCover,
          scene: this.scene,
          scene_id: this.sceneId,
          union: this.scene === 5,
          creativeElements: deepCopy(cTemplate)
        },
        ideaParam
      )
      ideaParam = Object.assign({}, ideaParam, {
        ideaName: `创意组${len + 1}`,
        creative_name: this.formItem.creative_name || this.planName
      })

      this.creativeData.push(deepCopy(ideaParam))
      this.setIdea(this.creativeData.length - 1)
      timeout(60).then(() => {
        this.$refs.barContent[0] && (this.$refs.barContent[0].scrollLeft = 3000)
      })
    },
    setIdea(index) {
      const item = this.creativeData[index]
      this.creativeData.forEach((ret) => {
        this.$set(ret, 'check', false)
      })
      this.$set(item, 'check', true)
    },
    delIdea(index) {
      const idx = this.creativeData.findIndex((ret) => ret.check)
      const len = this.creativeData.length
      if (len < 2) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: '不能删除最后一个创意组'
        })
        return
      }
      // 删除自己
      if (index === idx) {
        if (index > 0) this.setIdea(index - 1)
        else this.setIdea(1)
      }
      this.creativeData.splice(index, 1)
    },
    valid(ret) {
      const rules = [
        {
          name: 'ideaName',
          require: true,
          min: 1,
          max: 20,
          desc: '创意组名称'
        },
        {
          name: 'creative_name',
          require: true,
          min: 1,
          max: 96,
          desc: '创意名称'
        },
        {
          name: 'scene_id',
          relyon: 'scene',
          relyvalue: 2,
          min: 1,
          require: true,
          desc: '场景位置'
        },
        {
          name: 'creatives',
          relyon: 'unit_type',
          relyvalue: 4,
          min: 1,
          require: true,
          desc: '自定义创意',
          msg: '创意样式不能为空！'
        },
        {
          name: 'code',
          relyon: 'gift',
          relyvalue: true,
          require: true,
          min: 1,
          max: 20,
          pattern: '^[A-Za-z0-9]+$',
          desc: '礼包码'
        },
        {
          name: 'creative_tag',
          min: 1,
          require: true,
          desc: '创意标签'
        },
        {
          name: 'creative_category',
          require: true,
          desc: '创意分类'
        }
      ]
      return this.invalidPlus(ret, rules)
    },
    mergeCreative(creatives) {
      return creatives.map((ret) => {
        const adcreative_elements = ret.creative_material_type ? this.build(ret.template) : this.buildSmart(ret.template)
        ret.adcreative_elements = adcreative_elements
        ret.fail = clearStrKey(adcreative_elements) // 双引号不提交
        return ret
      })
    },
    /**
     * @description: 自定义创意
     * @param {*} item
     */
    build(item) {
      if (!isArray(item)) throw new Error('合并素材错误，素材原型非数组')
      const adcreative = {}
      item.forEach((ret) => {
        if (['ELEMENT_TYPE_COVER', 'ELEMENT_TYPE_IMAGE'].includes(ret.element)) adcreative.image_token = ret[ret.name]
        else if (ret.element === 'ELEMENT_TYPE_VIDEO') adcreative.photo_id = ret[ret.name]
        else if (ret.element === 'ELEMENT_TYPE_ENUM') {
          const {
            restriction: { enumeration }
          } = ret
          adcreative.action_bar_text = enumeration.map((ret) => ret.value)[ret[ret.name] - 1]
        } else if (ret.element === 'ELEMENT_TYPE_ENUMS') {
          adcreative.new_expose_tag = ret[ret.name].map((ret) => {
            return { text: ret }
          })
        } else if (ret.element === 'ELEMENT_TYPE_TEXTAREA') adcreative.description = trim(ret[ret.name])
        else adcreative[ret.name] = trim(ret[ret.name])
      })
      return adcreative
    },
    /**
     * @description: 程序化创意
     * @param {*} item
     */
    buildSmart(item) {
      if (!isArray(item)) throw new Error('合并素材错误，素材原型非数组')
      const adcreative = {}
      const dimension = { vertical: 1, horizontal: 2 }
      item.forEach((ret) => {
        if (ret.name === 'cover_image_tokens') {
          // 字段废弃
        } else if (['cover_slogans', 'captions'].includes(ret.name)) {
          adcreative[ret.name] = ret.children.map((met) => trim(met[met.name]))
        } else if (['photo_ids'].includes(ret.name)) {
          adcreative.photo_list = ret.children.map((c) => ({
            photo_id: c[c.name],
            cover_image_token: c.cover,
            creative_material_type: dimension[c.name]
          }))
        } else if (['sticker_styles'].includes(ret.name)) {
          adcreative[ret.name] = ret.children.filter((met) => met.check).map((met) => met.sticker_style_id)
        } else {
          const {
            restriction: { enumeration }
          } = ret
          adcreative[ret.name] = enumeration.map((ret) => ret.value)[ret[ret.name] - 1]
        }
        if (isArray(adcreative.sticker_styles) && !adcreative.sticker_styles.length) delete adcreative.cover_slogans
      })
      return adcreative
    },
    async submit() {
      this.verify = false
      this.formErr = false
      this.errRes = []

      timeout(100).then(() => {
        // 发起验证
        const customValids = this.creativeData.map((ret) => {
          const err = [...this.valid(ret)]
          const element = [...this.invalidExtand(ret)]

          return { err, element }
        })

        const errState = customValids.some((met, idx) => {
          this.index = idx
          this.errRes = met.err
          if (met.err.length > 0) return true
          else {
            const el = met.element.some((e, i) => {
              this.idx = i
              return e.stat.some((v) => !v)
            })

            if (el) {
              this.errRes.push({
                feild: '创意素材',
                msg: this.formItem.unit_type === 7 ? '验证不通过，请逐个检查' : `创意${this.idx + 1}验证不通过请检查`
              })
            }
            return el
          }
        })
        if (this.errRes.length || errState) {
          typeof this.index === 'number' && this.setIdea(this.index) // 切到创意组
          timeout(200).then(() => {
            typeof this.idx === 'number' && this.setCurrent(this.idx)
            this.verify = true
            this.formErr = true
          })
          // eslint-disable-next-line
          return false // 如果错误中断
        }
        this.jump()
      })
    },
    jump() {
      const creative_params = deepCopy(this.creativeData).map((ret) => {
        const pullArray = [
          'ideaName',
          'creative_name',
          'scene',
          'scene_id',
          'unit_type',
          'adcreative_elements_array',
          'creative_details',
          'gift',
          'code',
          'target_action_type',
          'asset_mining',
          'smart_cover',
          'creative_category',
          'creative_tag'
        ]
        Object.assign(ret, {
          package_name: ret.creative_name,
          adcreative_elements_array: this.mergeCreative(ret.creatives),
          creative_details: ret.creativeDetails,
          smart_cover: Boolean(ret.smart_cover)
        })

        if (ret.unit_type === 4) {
          // 自定义创意
          pullArray.push('creative_name')
        } else {
          pullArray.push('package_name')
        }
        return pullKeys(pullArray, ret)
      })

      // setSession('creative_params_back', this.creativeData)
      // setSession('creative_params', creative_params)

      setLocalforage('creative_params_back', this.creativeData)
      setLocalforage('creative_params', creative_params).then(() => {
        this.$router.push({ name: 'kuaishoulocalbatch' })
      })
    },
    back() {
      if (this.show || this.creativeData.length) {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>当前编辑数据未保存，返回将丢失编辑数据。</p><p>是否保存当前数据</p>',
          loading: true,
          okText: '是',
          cancelText: '否',
          onOk: () => {
            // setSession('creative_params_back', this.creativeData)
            setLocalforage('creative_params_back', this.creativeData)
            timeout(800).then(() => {
              this.$Modal.remove()
              this.$router.push({
                name: 'kuaishoulocalplan',
                query: { t: 'edit' }
              })
            })
          },
          onCancel: () => {
            this.$router.push({
              name: 'kuaishoulocalplan',
              query: { t: 'edit' }
            })
          }
        })
      } else {
        this.$Message.error('页面数据加载中，请等待...')
        return false
      }
    }
  },
  created() {
    const plan_info = getSession('inner_plan_params') || {}
    const out_plan_info = getSession('outer_plan_params') || {}
    const { unit_type, union, smart_cover } = out_plan_info

    this.deliveryMethod = Number(getSession('deliveryMethod'))

    this.planName = plan_info.plan_name || ''
    this.gameId = parseInt(plan_info.game_id)
    this.platform = parseInt(plan_info.ch_platform_id) || 1
    this.unitType = unit_type || 4
    this.smartCover = smart_cover || 0
    if (union) {
      // 优选/联盟/按场景
      this.sceneId = [5]
      this.scene = 5
    } else {
      this.sceneId = [1]
      this.scene = 1
    }
    // 初始化账号数据
    adAccount({ mediaId: this.media, authFlag: 1 }).then((accounts) => {
      if (isArray(accounts)) {
        this.accountData = accounts.map((ret) => {
          return { id: ret.id, name: ret.name, children: [], xhr: false, disabled: false }
        })
      }
    })
    this.preloadData()
  }
}
</script>
<style lang="scss">
.el-option-slot {
  display: flex;
  align-items: center;
  > span {
    line-height: 1;
  }
}
</style>
<style lang="scss" scoped>
.c-idea {
  position: relative;
  height: inherit;

  .m-bread {
    line-height: 20px;
    margin-bottom: 12px;
  }

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 96px);
  }

  .col-flex {
    min-height: 32px;
    display: flex;
    align-items: center;
  }

  .c-idea-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      button {
        margin-left: 8px !important;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  // 多个素材
  .m-creative-btn {
    border-radius: 4px;
    border: solid 1px #efefef;
    position: relative;
    display: inline-block;
    line-height: 32px;
    padding: 0 12px;
    margin-right: 12px;
  }

  .m-current {
    color: #2b85e4;
    border-color: #2b85e4;
  }

  .m-creat-btn {
    color: #2b85e4;
  }

  .m-remove {
    position: absolute;
    cursor: pointer;
    color: #fff;
    width: 11px;
    height: 11px;
    line-height: 11px;
    font-size: 60%;
    border-radius: 9px;
    background-color: #ff635c;
    text-align: center;
    display: block;
    z-index: 11;
    top: -6px;
    right: -3px;
    transition: display 0.2s ease-in-out;
  }

  // 暂无创意
  .c-nodata {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .ivu-icon {
      display: inline-block;
    }

    span {
      color: #bebebe;
      font-size: 14px;
    }
  }
}

.c-idea-bar {
  position: relative;
  flex: auto;
  display: flex;
  justify-content: space-between;
  padding: 15px 12px 15px 48px;
  background-color: #ffffff;
  white-space: nowrap;

  .c-bar-content {
    overflow-x: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: inherit;
    display: inline-block;
    flex: auto;
    padding: 5px 0;

    .m-creative-btn {
      border-radius: 4px;
      border: solid 1px #efefef;
      position: relative;
      display: inline-block;
      line-height: 32px;
      padding: 0 12px;
      margin-right: 12px;

      .m-creat-btn {
        color: #2b85e4;
      }

      .m-remove {
        position: absolute;
        cursor: pointer;
        color: #fff;
        width: 11px;
        height: 11px;
        line-height: 11px;
        font-size: 60%;
        border-radius: 9px;
        background-color: #ff635c;
        text-align: center;
        display: block;
        z-index: 11;
        top: -6px;
        right: -3px;
        transition: display 0.2s ease-in-out;
      }
    }

    .m-current {
      color: #ffffff;
      border-color: #2b85e4;
      background-color: #2b85e4;
    }
  }

  .c-add-btn {
    padding-top: 6px;
    text-align: right;

    button {
      margin-left: 10px !important;

      &:first-child {
        margin-left: 0 !important;
      }
    }
  }
}

.row-item {
  align-items: flex-start;

  span.item-field {
    height: 32px;
    line-height: 32px;
  }
}

.ivu-affix .c-idea-bar {
  border-bottom: 1px solid #e8eaec;
}
</style>
